export enum OrderDetailsPaymentMethod {
  CARD = 'CARD',
  CASH = 'CASH',
  PAID_ONLINE = 'PAID',
}
